import { Chip, Button } from "@mui/material";
import { styled, css } from "@mui/material/styles";
import AnamnesisAttention from "../../assets/icons/AnamnesisAttention.js";
import AnamnesisDone from "../../assets/icons/AnamnesisDone.js";
import AnamnesisInProgress from "../../assets/icons/AnamnesisInProgress.js";
import { DocumentStatus } from "../../patient-today-list.types.js";
import "react/jsx-runtime";
const statusColors = (theme) => ({
  [DocumentStatus.INVALID]: { border: "#FF647C", text: theme.palette.error[500], background: theme.palette.error[50] },
  [DocumentStatus.MISSING]: { border: "#FF647C", text: theme.palette.error[500], background: theme.palette.error[50] },
  [DocumentStatus.IN_PROGRESS]: {
    border: "#C99B0F",
    text: theme.palette.warning[600],
    background: theme.palette.warning[50]
  },
  [DocumentStatus.DONE]: { border: "#51AA76", text: theme.palette.success[500], background: theme.palette.success[50] }
});
const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "isOpen" && prop !== "status"
})`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 2px;
  background: transparent;

  ${({ theme, status, isOpen }) => status && statusColors(theme)[status] && css`
      border-color: ${isOpen ? statusColors(theme)[status].border : "transparent"};

      & button {
        color: ${statusColors(theme)[status].text};
      }

      &:hover {
        border-radius: 50%;
        background-color: ${statusColors(theme)[status].background};
      }
    `}

  .MuiChip-label {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: transparent;
  }
`;
const StatusButton = styled(Button)`
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;
const statusIconStyles = {
  width: "18px",
  height: "18px"
};
const AnamnesisAttentionIcon = styled(AnamnesisAttention)(statusIconStyles);
const AnamnesisDoneIcon = styled(AnamnesisDone)(statusIconStyles);
const AnamnesisInProgressIcon = styled(AnamnesisInProgress)(statusIconStyles);
export {
  AnamnesisAttentionIcon,
  AnamnesisDoneIcon,
  AnamnesisInProgressIcon,
  StatusButton,
  StatusChip
};
